
import React from 'react';
import ZNetwork from "./znetwork.js";
import ZProps from "./zprops.js";
import ZLog from "./zlog.js";
import ZUtil from "./zutil.js";
import { APP } from "./App.js";
import AMC from './AMC';
import AMCForm from './AMCForm';
import PleaseStandBy from "./PleaseStandBy.js";
import ZooGenericTrackedButton from './ZooGenericTrackedButton';
import ZooErrorFoundPage from "./ZooErrorFoundPage.js";
import AMCConstants from "./AMCConstants.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

export default class ZooGotModelPage extends React.Component {
	constructor(props) {
		super(props);
		let cookies = JSON.parse(ZUtil.getCandy("gotmodel") || "{}");
		this.state = { task: cookies.task || "register", format: cookies.format || "h5", values: cookies || {} };
		this.prototypes = {};
	}
	componentDidMount() {
		this.setState({state: "loading"});
		APP.setTitle("Got Model?");
		AMC.track(AMCConstants.GOT_MODEL_TRACKING_URI);
		let reg = "core/modelsource/ATMHTTPModelSource";
		let up = "core/modelsource/ATMS3ModelSource";
		AMC.list([reg, reg + ".imp", reg + ".spec", up, up + ".imp", up + ".spec"], (err, things) => {
			this.prototypes["register"] = things[0];
			this.prototypes["register.imp"] = things[1];
			this.prototypes["register.spec"] = things[2];
			this.prototypes["upload"] = things[3];
			this.prototypes["upload.imp"] = things[4];
			this.prototypes["upload.spec"] = things[5];
			this.prototypes["register.spec"].fields = 
				AMC.mergeSpecs(this.prototypes["register.spec"].fields, AMCConstants.COMMON_SPEC);
			this.prototypes["upload.spec"].fields = 
				AMC.mergeSpecs(this.prototypes["upload.spec"].fields, AMCConstants.COMMON_SPEC);

			this.prototypes["register.spec"].fields =
				this.prototypes["register.spec"].fields.filter( f => f.field !== "owner" && f.field !== "group" );
			this.prototypes["upload.spec"].fields =
				this.prototypes["upload.spec"].fields.filter( f => f.field !== "owner" && f.field !== "group" );
			let spec = this.prototypes["upload.spec"];
			this.fields = {};
			this.fields.upload = [
				{ name: "Task", field: "task", kind: "radio", required: true, "default": "register", choices: ["register", "upload"], hint: "Whether to register url of model or upload model from you PC to the server" },
				...(spec ? spec.fields : []),
				{ name: "Model data", field: "upload", kind: "upload", required: true, enabled: true, hint: "Choose file containing model weights to upload" }
			];
			spec = this.prototypes["register.spec"];
			this.fields.register = [
				{ name: "Task", field: "task", kind: "radio", required: true, "default": "register", choices: ["register", "upload"], hint: "Do you want to register the url of the model or do you want to upload the model from your PC to the server" },
				...(spec ? spec.fields : [])
			];
			this.setState({state: "loaded" });
		});
	}
	componentWillUnmount() {
		APP.setTitle(null);
	}
	onInvalidChange = (properties) => {
		ZUtil.setCandy("gotmodel", properties);
		if (properties.task !== this.state.task) {
			this.setState({ task: properties.task }); 
		}
	}
	onChange = (properties) => {
		ZUtil.setCandy("gotmodel", properties);
		if (properties.task !== this.state.task) {
			this.setState({ task: properties.task }); 
		}
	}
	onUploading = (file, callback) => {
		this.setState({ file: file, values: { ...this.state.values, upload: file.name } });
	}
	onMore = (e) => {
		e.preventDefault();
		this.setState({ file: null, state: null, values: { ...this.state.values, upload: null, name: null } });
	}
	onSave = (properties) => {
		let { task, format, file } = this.state;
		properties.kind = "model";
		properties.published = true;
		properties.format = format;
		this.setState({ state: "saving", error: null });
		let user = ZProps.get("user");
		properties.uri = user.uri + "/model/" + ZUtil.idify(properties.name) + "-model." + properties.format;
		// add fields for this new type that can be refenced from any service by refing this type
		// create to build imp and spec as well...
		delete properties.task;
		delete properties.upload;
		// 1. see if uri is in use...
		ZNetwork.get("thing", properties.uri, (err, thing) => {
			if (thing) {
				APP.areYouSure(() => { this._onSave(properties, task, file) }, "Are you sure you want to overwrite existing model?");
			} else {
				this._onSave(properties, task, file);
			}
		});
	}
	_onSave(properties, task, file) {
		properties = Object.assign(this.prototypes[task], properties);
		if (task === "upload") {
			properties.link = "s3:" + properties.uri;
		}
		AMC.create(properties, this.prototypes[task + ".spec"], this.prototypes[task + ".imp"], (err, payload) => {
			if (err) {
				return this.setState({ state: "error", error: err });
			}
			ZProps.set(payload.component.uri, payload.component);
			ZProps.set(payload.spec.uri, payload.spec);
			ZProps.set(payload.imp.uri, payload.imp);
			let newthing = payload.component;
			if (task === "upload") {
				ZNetwork.post("upload", { filename: file.name, properties: newthing, filetype: file.type }, (err, data) => {
					if (err) {
						return this.setState({ state: "error", error: err });
					}
					ZNetwork.uploadToS3(file, data.signed_request, (err, filename) => {
						ZLog.debug("Uploading to S3 complete: " + filename);
						if (err) {
							return this.setState({ state: "error", error: err });
						}
						AMC.track(AMCConstants.GOT_MODEL_SAVE_TRACKING_URI);
						this.setState({ saved_uri: newthing.uri, state: "saved" });
					});
				});
			} else {
				AMC.track(AMCConstants.GOT_MODEL_SAVE_TRACKING_URI);
				this.setState({ state: "saved", saved_uri: newthing.uri });
			}
		});
	}
	render() {
		let { task, values, error, state, saved_uri } = this.state;

		let fields = this.fields ? this.fields[task] : [
			{ name: "Task", field: "task", kind: "radio", required: true, "default": "register", choices: ["register", "upload"], hint: "Whther to register url of model or upload model from you PC to the server" }
		];
		if (error) {
			//return <ZooErrorFoundPage />;
		}

		let suggestions = 
			<div className="ZooSearchPageServicesSuggestions">
				<a href={"/search/is:service"}>all services</a>
				<a href={"/search/is:algorithms"}>all algorithms</a>
				<a href={"/search/is:datasource"}>all data</a>
			</div>
		return (
			<div className="ZooGeneralPage ZooGotPage"> 
				<div className="ZooGeneralPageHeader">
					{ error ?  <div style={{opacity: 0.2}}><ZooErrorFoundPage /></div> : <h1>Got model?</h1> }
				</div>
				{ state === "saved" ?
					<AMCForm fields={fields} values={values} buttons={
						<span>
							<FontAwesomeIcon style={{color: "#0a0"}} icon={faCheck} /> 
							Saved to <a href={"/zoo/" + saved_uri}>{saved_uri}</a>
							<button className="AMCButton" href="" onClick={this.onMore}>Got another?</button>
						</span> } 
					/>
				:
					<AMCForm key={task} fields={fields} values={values} onChange={this.onChange} onInvalidChange={this.onInvalidChange} onSave={this.onSave} saveButton={ <ZooGenericTrackedButton label={task === "register" ? "Register Model" : "Upload Model"} tracking_uri={AMCConstants.GOT_MODEL_SAVE_TRACKING_URI} callback={this.onSave} />} onUploading={this.onUploading}  />
				}
				{suggestions}
				{ state === "loading" || state === "saving" ? <PleaseStandBy /> : '' }
			</div>
		);

	}
}



// WEBPACK FOOTER //
// ./src/ZooGotModelPage.js